<template>
  <v-card hover :to="'/debt/' + debt.orderNr" height="100%" class="debt-card">
    <v-card-title>
      <v-row no-gutters>
        <v-col cols="12" class="text-center">
          <h5 class="mt-0 mb-3 text-h5">{{ debt.creditor.name }}</h5>
          <p class="mb-0" v-if="debt.dueDate !== null">{{ $t('dueDate') }}: {{ debt.dueDate | formatDate }}</p>
        </v-col>
      </v-row>
    </v-card-title>
    <v-divider></v-divider>
    <v-card-text>      
      <v-row no-gutters>
        <v-col cols="12" class="text-center">
          <debt-wheel :value="debt.debtSummary.progress"
                      :size="150"
                      :width="10"
                      :rotate="-90"
                      color="color-new-link-blue">
            <div class="d-flex flex-column">
              <div class="grey--text">{{ $t('left') }}</div>
              <div class="text-subtitle-1 color-new-link-blue--text"><b>{{ debt.debtSummary.left | currency }}</b></div>
            </div>
          </debt-wheel>
          <p class="mb-1 mt-2">
            <span>{{ $t('debtState') }}: </span>
            <span :class="'debt-state state-' + debt.debtSummary.state.colorGroup">{{ $t('state.' + debt.debtSummary.state.state) }}</span>
          </p>
          <p class="mb-2">
            {{ $t('paid') }}
            {{ debt.debtSummary.totalPaid | currency }} /
            {{ debt.debtSummary.total | currency }}
          </p>
          <v-btn tile :color="buttonColor" dark class="px-4">{{ buttonText }}</v-btn>
        </v-col>
      </v-row>
    </v-card-text>
  </v-card>
</template>

<script>
  import moment from 'moment'

  export default {
    props: ['debt'],
    computed: {
      isDueDateInPast () {
        if (this.debt.dueDate === null) {
          return false
        } else if (moment(this.debt.dueDate) <= moment().add(2, 'days')) {
          return true
        } else {
          return false
        }
      },
      buttonColor () {
        if (this.debt.debtSummary.state.state === 4) {
          return 'red'
        } else if (this.isDueDateInPast) {
          return 'color-orange'
        } else {
          return 'primary'
        }
      },
      buttonText () {
        if (this.debt.debtSummary.state.state === 4) {
          return this.$t('payNow')
        } else if (this.isDueDateInPast) {
          return this.$t('payQuickly')
        } else {
          return this.$t('payWholeDebt')
        }
      }
    }
  }
</script>
